<div class="content-container">
  @if (isLoading) {
  <div class="loading-container" style="height: 350.5px">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
  } @else { @if (mfa) { @if (tooltipStep >= 0) {
  <app-animated-tooltip
    [ngStyle]="{ top: sectionHeights[tooltipStep] + 'px' }"
    (stepChange)="onTooltipStepChange($event)"
  ></app-animated-tooltip>
  }
  <h3>{{ 'setUpTwoFactor.authenticatorApp.title' | translate }}</h3>
  <h4>{{ 'setUpTwoFactor.authenticatorApp.text' | translate }}</h4>
  <div class="section-container" style="margin-bottom: 0">
    <div class="section" #section>
      <div class="section-content">
        <h6>
          {{ 'setUpTwoFactor.authenticatorApp.step' | translate: { step: 1 } }}
        </h6>
        <h5>
          {{ 'setUpTwoFactor.authenticatorApp.step1Title' | translate }}
        </h5>
        <p>
          {{ 'setUpTwoFactor.authenticatorApp.step1Text' | translate }}
        </p>
      </div>
    </div>
    <hr />
    <div class="section" #section>
      <div class="section-content">
        <h6>
          {{ 'setUpTwoFactor.authenticatorApp.step' | translate: { step: 2 } }}
        </h6>
        <h5>
          {{ 'setUpTwoFactor.authenticatorApp.step2Title' | translate }}
        </h5>
        <p>
          {{ 'setUpTwoFactor.authenticatorApp.step2Text' | translate }}
        </p>
        <h5 style="margin-top: 12px">
          {{ 'setUpTwoFactor.authenticatorApp.step2bTitle' | translate }}
        </h5>
        <p style="height: 20px">{{ mfa.key }}</p>
      </div>
      <div class="section-image">
        <img
          [src]="mfa.qrCodeUrl"
          [alt]="'setUpTwoFactor.authenticatorApp.step2Alt' | translate"
        />
      </div>
    </div>
    <hr />
    <div class="section" #section>
      <div class="section-content" style="width: 436px">
        <h6>
          {{ 'setUpTwoFactor.authenticatorApp.step' | translate: { step: 3 } }}
        </h6>
        <h5>
          {{ 'setUpTwoFactor.authenticatorApp.step3Title' | translate }}
        </h5>
        <p>
          {{ 'setUpTwoFactor.authenticatorApp.step3Text' | translate }}
        </p>
        <div class="input-container">
          <form [formGroup]="otpForm" (ngSubmit)="onActivate()">
            <mat-form-field appearance="outline">
              <input
                matInput
                name="mfaCode"
                type="text"
                formControlName="mfaCode"
                maxlength="6"
                [placeholder]="
                  'setUpTwoFactor.authenticatorApp.placeholder' | translate
                "
                required
              />
              @if (otpForm.get('mfaCode').hasError('incorrect')) {
              <mat-icon class="error-icon" matSuffix>error_outline</mat-icon>
              }
            </mat-form-field>
            @if (otpForm.get('mfaCode').hasError('incorrect')) {
            <mat-error>{{
              'setUpTwoFactor.mfaInvalidCodeError' | translate
            }}</mat-error>
            }
          </form>

          <button
            mat-flat-button
            class="action-button activate-button"
            color="primary"
            type="submit"
            (click)="onActivate()"
            [disabled]="!otpForm.valid || isActivating"
          >
            @if (isActivating) {
            <mat-spinner diameter="20"></mat-spinner>
            } @else {
            {{ 'setUpTwoFactor.authenticatorApp.activate' | translate }}
            }
          </button>
        </div>
      </div>
    </div>
  </div>
  } @else {
  <app-mfa-fail [errorType]="MfaErrors.IS_QR_CODE_FAIL"></app-mfa-fail>
  } }
</div>
